import { RegisteredComponent } from "@builder.io/sdk-react";
import type { IconBlockProps } from "./IconBlock";
import { DAY_IN_SECONDS } from "@/constants";

export const iconBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Icon",
  image:
    "https://p1.aprimocdn.net/solarwinds/ea594f6d-9cc2-4ce4-b6fb-b2420142fc67/SW_Logo_Flame_Web_Silver_Original%20file.svg",
  inputs: [
    {
      name: "icon",
      type: "AprimoAssetSelector",
      options: {
        searchingExpression:
          'Contentstatus = "Released" AND File.Version.FileType.Kind = "SVG" AND Classification.NamePath = "/DAM/Audience/External" AND Classification.NamePath = "/DAM/Status/Available"',
      },
      required: true,
      localized: false,
      helperText:
        "Select the icon from the DAM (Aprimo). Only icons which are permitted to use on the website are selectable; therefore, archived, draft or internal assets can't be selected.",
    },
    {
      name: "color",
      type: "color",
      localized: false,
    },
    {
      name: "width",
      type: "number",
      localized: false,
    },
    {
      name: "height",
      type: "number",
      localized: false,
    },
  ],
};

export const remapProps = async (props: IconBlockProps) => {
  if (props.icon) {
    const response = await fetch(props.icon, {
      next: {
        revalidate: DAY_IN_SECONDS,
        tags: ["image", "image-svg", props.icon],
      },
    });
    const svg = await response.text();

    return {
      ...props,
      icon: svg,
    };
  }
  return props;
};
